import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import Card from '../components/Card';
import WhatsApp from '../services/WhatsApp';
import Carousel from '../components/Carousel';
import { useI18n } from '../i18n/LanguageProvider';
import { contactInfo } from '../data/contactInfo';

const Home = () => {
  const { t, services } = useI18n();
  const wa = WhatsApp.link(contactInfo.phone, 'Hi! I want to book a cleaning with Sparklean.');

  return (
    <>
      <section className="hero">
        <div className="container grid-2" style={{alignItems:'center'}}>
          <div>
            <span className="badge">{t('hero.badge')}</span>
            <h1>{t('hero.title')}</h1>
            <p className="lead">{t('hero.lead')}</p>
            <div style={{display:'flex', gap:12, flexWrap:'wrap'}}>
              <Link to="/booking"><Button variant="primary">{t('hero.cta')}</Button></Link>
              <a href={wa} target="_blank" rel="noreferrer"><Button variant="secondary">{t('hero.whatsapp')}</Button></a>
            </div>
            <p className="muted mt-2">{t('home.licensed')}</p>
          </div>
          <div aria-hidden="true">
            <img src="/assets/ce083c8e-5d6f-4ac1-8356-79fde7c98be3.png" alt="" />
          </div>
          <div className="promo-banner" role="note">
            <span className="promo-banner__badge">{t('home.firstCleanDiscountBadge')}</span>
            <span className="promo-banner__text">{t('home.firstCleanDiscount')}</span>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="mb-2">{t('home.servicesTitle')}</h2>

          <div className="hcards">
            {services.map(s => (
              <Link key={s.slug} to={`/services/${s.slug}`} className="fade-in" style={{textDecoration:'none'}}>
                <div className="card hcard">
                  <div className="media">
                    {/* превью: без стрелок и без точек, высота стабильна */}
                    <Carousel images={s.images} alt={s.title} showControls={false} showDots={false} />
                  </div>
                  <div className="content">
                    <div>
                      <strong style={{fontSize:'1.1rem'}}>{s.title}</strong>
                      <p className="muted" style={{margin:'.4rem 0 0'}}>{s.short}</p>
                    </div>
                    <div className="mt-1">
                      <span className="btn ghost" aria-hidden="true">{t('home.seeDetails')}</span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="section" style={{background:'var(--bg-soft)'}}>
        <div className="container grid-2">
          <div>
            <h2>{t('home.whyTitle')}</h2>
            <ul className="list-clean mt-2">
              {t('home.reasons', []).map((r, idx) => (
                <li className="check" key={idx}>{r}</li>
              ))}
            </ul>
          </div>
          <div>
            <div className="card" style={{padding:'1.25rem'}}>
              <strong>{t('home.areaTitle')}</strong>
              <p className="muted">{t('home.areaCopy')}</p>
              <Link to="/booking"><Button variant="primary">{t('home.quote')}</Button></Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Home;
